let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8BKZS")).then(() => parcelRequire('dRBFA'));